var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"jz-hamburger",class:[
    _vm.data.staticClass,
    _vm.data.class,
    { 'is-active': _vm.props.active },
    ("transition-" + (_vm.props.transition))
  ]},_vm.listeners),[_c('div',{staticClass:"hamburger-steak"})])}
var staticRenderFns = []

export { render, staticRenderFns }